// Why the reception of a foja cannot be operated in its current state, or null when it can.
const NOTICES = {
  borrador: { tone: 'danger', text: 'La recepción formal exige despacho confirmado. Primero hay que registrar la salida real de la foja.' },
  cerrada: { tone: 'danger', text: 'La recepción formal exige despacho confirmado. Primero hay que registrar la salida real de la foja.' },
  recibida: { tone: 'info', text: 'La recepción de esta foja ya está cerrada.' },
  anulada: { tone: 'danger', text: 'La foja está anulada: no admite recepción.' },
};

export function receptionNotice(estado) {
  return NOTICES[estado] || null;
}
